module.exports = __webpack_public_path__ + "static/media/Herosection.be16fa91.png";